import { reactive, ref } from 'vue'
import { useApi } from '@/functions/api'

export function useSupplierList () {
  const api = useApi()
  const suppliers = ref<Supplier[]>([])
  const loading = ref(false)

  const getData = async () => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<Supplier>>('warehouse/supplier')
      suppliers.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    suppliers,
  }
}

export function useSupplierCreate () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const form = reactive({
    name: '',
    phone: '',
    address: '',
  })

  const submitForm = async () => {
    try {
      submitting.value = true
      return await api.POST<Supplier>('warehouse/supplier', form)
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
  }
}

export function useSupplierEdit () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const form = reactive({
    name: '',
    phone: '',
    address: '',
  })

  const submitForm = async (id: number) => {
    try {
      submitting.value = true
      return await api.PUT<Supplier>(`warehouse/supplier/${id}`, form)
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
  }
}

export function useSupplierDelete () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitDelete = async (id: number) => {
    try {
      submitting.value = true
      await api.DELETE(`warehouse/supplier/${id}`)
      return id
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    errors,
    submitting,
    submitDelete,
  }
}
